/**
 * {@docCategory SpinButton}
 */
export var KeyboardSpinDirection;
(function (KeyboardSpinDirection) {
  KeyboardSpinDirection[KeyboardSpinDirection["down"] = -1] = "down";
  KeyboardSpinDirection[KeyboardSpinDirection["notSpinning"] = 0] = "notSpinning";
  KeyboardSpinDirection[KeyboardSpinDirection["up"] = 1] = "up";
})(KeyboardSpinDirection || (KeyboardSpinDirection = {}));